import baseGetTag from "./_baseGetTag.js";
import isObjectLike from "./isObjectLike.js";
var argsTag = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}
export {
  baseIsArguments as default
};
//# sourceMappingURL=_baseIsArguments.js.map
